import { generateChildrenFromList } from 'cms/parsers';
import { Box, ThreeColumn } from 'dma-ui-kit';
import styled from 'styled-components';

const Container = styled(Box)`
  padding: 0 12px;

  @media (min-width: 1025px) {
      padding: 0 48px;
  }
  
  @media (max-width: 1024px) {
      padding: 0 24px;
  }

  max-width: 1250px;
  margin-bottom: 20px;
  & h2 {
    margin: 5px 0;
  }
  & h5 {
    margin: 5px 0;
  }
`;

const Column = styled(Box)`
  padding: 0 12px;

  @media (min-width: 1025px) {
      padding: 0 48px;
  }
  
  @media (max-width: 1024px) {
      padding: 0 24px;
  }

  max-width: 1250px;
  margin-bottom: 20px;
  & h2 {
    margin: 5px 0;
  }
  & h5 {
    margin: 5px 0;
  }
`;

const ThreeColumnParagraph = (props) => {
    const { relationships } = props.paragraph;

    const children_left = generateChildrenFromList(relationships.field_left_column.data);
    const children_center = generateChildrenFromList(relationships.field_center_column.data);
    const children_right = generateChildrenFromList(relationships.field_right_column.data);

    return (
        <Container>
            <ThreeColumn>
                <div>{children_left}</div>
                <div>{children_center}</div>
                <div>{children_right}</div>
            </ThreeColumn>
        </Container>
    );
};

export default ThreeColumnParagraph;